import React from 'react';
import styled from '@emotion/styled';

const primary = '#fec823';

const FormFieldContainer = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  margin-left: 15px;
  border-top: 1px solid #ddd;

  &:first-of-type {
    border-top: none;
  }
`;

const Label = styled.label`
  width: 20%;
  min-width: 70px;
  padding: 11px 0;
  color: #cd9e1e;
  overflow: hidden;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-right: 1px solid #ddd;
`;

const Input = styled.input`
  font-size: 16px;
  width: 100%;
  padding: 11px 15px 11px 8px;
  color: #987618;
  background-color: transparent;
  animation: 1ms void-animation-out;

  &::placeholder {
    color: #87bbfd;
  }
`;

const Select = styled.select`
  font-size: 16px;
  width: 100%;
  padding: 11px 15px 11px 8px;
  color: #fff;
  background-color: transparent;
  animation: 1ms void-animation-out;
  border: 0;

  &::placeholder {
    color: #87bbfd;
  }
  &:focus, &:active {
    border: 0;
  }
`;

const FormField = ({ label, type, name, placeholder, required, value, disabled, onChange }: any) => {
  return (
    <FormFieldContainer>
      <Label htmlFor={name}>{label}</Label>
      <Input onChange={onChange} name={name} type={type} placeholder={placeholder} required value={value} disabled={disabled} />
    </FormFieldContainer>
  );
};

const FormSelectField = ({ label, type, name, placeholder, required, children, autocomplete }: any) => {
  return (
    <FormFieldContainer>
      <Label htmlFor={name}>{label}</Label>
      <Select name={name} placeholder={placeholder} required autoComplete={autocomplete}>
        {children}
      </Select>
    </FormFieldContainer>
  );
};
export { FormSelectField };
export default FormField;
